import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';

// Statically import the language-specific components for better SEO.
import PrivacyPolicyEN from './en/PrivacyPolicy';
import PrivacyPolicyHE from './he/PrivacyPolicy';

const PrivacyPolicy = () => {
  const lang = useLanguage();

  let LanguageSpecificComponent;

  switch (lang) {
    case 'he':
      LanguageSpecificComponent = PrivacyPolicyHE;
      break;
    case 'en':
    default:
      LanguageSpecificComponent = PrivacyPolicyEN;
      break;
  }

  return <LanguageSpecificComponent />;
};

export default PrivacyPolicy;
